import { SELECT_MULTI_EMAIL_CRM_OBJECTS } from 'email-management-lib/refactor/actions/actionTypes';
const initialState = [];
export default function selectedMultiEmailCrmObjects(state = initialState, action) {
  switch (action.type) {
    case SELECT_MULTI_EMAIL_CRM_OBJECTS:
      return action.payload.crmObjects;
    default:
      return state;
  }
}